// import React from "react";
// import { Link } from "react-router-dom";
// import { motion } from "framer-motion";
// import { useGetLatestBlogsPerCategoryQuery } from "../../redux/api/blogsApi";

// const FALLBACK_IMAGE = "/images/fallback.jpg";

// // ─── Variants (identical to Home.jsx) ─────────────────────────────────────────
// const sectionVariants = {
//   hidden: { opacity: 0, y: 24 },
//   visible: {
//     opacity: 1,
//     y: 0,
//     transition: { duration: 0.8, ease: "easeOut", staggerChildren: 0.12 },
//   },
// };
// const childVariants = {
//   hidden: { opacity: 0, y: 12 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
// };
// const dividerVariants = {
//   hidden: { scaleX: 0 },
//   visible: { scaleX: 1, transition: { duration: 0.6, ease: "easeOut", delay: 0.25 } },
// };
// const fadeUp = {
//   hidden: { opacity: 0, y: 20 },
//   visible: (i = 0) => ({
//     opacity: 1,
//     y: 0,
//     transition: { duration: 0.6, ease: "easeOut", delay: i * 0.1 },
//   }),
// };

// // ─── Helper ───────────────────────────────────────────────────────────────────
// const formatDate = (dateStr) => {
//   if (!dateStr) return null;
//   return new Date(dateStr).toLocaleDateString("en-US", {
//     month: "long",
//     day: "numeric",
//     year: "numeric",
//   });
// };

// // ─── Blog card ────────────────────────────────────────────────────────────────
// const BlogCard = ({ blog, index }) => {
//   const imageUrl = blog.images?.[0]?.url || FALLBACK_IMAGE;
//   const date = formatDate(blog.createdAt);
//   const title = blog.name || blog.title;

//   return (
//     <motion.article
//       custom={index}
//       variants={fadeUp}
//       initial="hidden"
//       whileInView="visible"
//       viewport={{ once: true, margin: "-60px" }}
//       className="group flex flex-col"
//     >
//       <Link to={`/blogs/${blog._id}`} className="flex flex-col h-full">

//         {/* Cover image */}
//         <div className="relative w-full aspect-[4/3] overflow-hidden bg-stone-200">
//           <img
//             src={imageUrl}
//             alt={title}
//             className="w-full h-full object-cover object-center transition-transform duration-700 ease-out group-hover:scale-[1.03]"
//             loading={index === 0 ? "eager" : "lazy"}
//             decoding={index === 0 ? "sync" : "async"}
//             width="600"
//             height="450"
//           />
//         </div>

//         {/* Text */}
//         <div className="pt-4 flex flex-col gap-1.5 flex-1">

//           {/* Category · Date */}
//           <div className="flex items-center gap-2 flex-wrap">
//             {blog.category && (
//               <p className="font-mono text-[0.6rem] tracking-[0.28em] uppercase text-stone-400">
//                 {blog.category}
//               </p>
//             )}
//             {blog.category && date && (
//               <span className="font-mono text-[0.6rem] text-stone-300">·</span>
//             )}
//             {date && (
//               <p className="font-mono text-[0.6rem] tracking-[0.2em] uppercase text-stone-400">
//                 {date}
//               </p>
//             )}
//           </div>

//           {/* Title */}
//           <h3
//             className="font-playfair font-normal text-stone-800 leading-snug group-hover:text-[#BC3F4A] transition-colors duration-300"
//             style={{ fontSize: "clamp(1rem, 2vw, 1.2rem)" }}
//           >
//             {title}
//           </h3>

//           {/* Description */}
//           {blog.description && (
//             <p className="font-sourcesans font-normal text-stone-500 leading-relaxed line-clamp-2 text-sm">
//            {blog.description.replace(/<[^>]*>/g, "").trim()}
//             </p>
//           )}

//           {/* Read cue */}
//           <p className="font-mono text-[0.6rem] tracking-[0.22em] uppercase text-[#BC3F4A]/70 mt-auto pt-2">
//             Read →
//           </p>

//         </div>
//       </Link>
//     </motion.article>
//   );
// };

// // ─── Skeleton ─────────────────────────────────────────────────────────────────
// const Skeleton = () => (
//   <section className="py-10 border-t border-stone-200">
//     <div className="max-w-6xl mx-auto px-6 md:px-12">
//       <div className="text-center mb-10 space-y-3">
//         <div className="h-2 w-24 bg-stone-200 rounded mx-auto animate-pulse" />
//         <div className="h-6 w-48 bg-stone-200 rounded mx-auto animate-pulse" />
//         <div className="h-[1.5px] w-12 bg-stone-200 mx-auto mt-4" />
//       </div>
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
//         {[...Array(3)].map((_, i) => (
//           <div key={i} className="space-y-3">
//             <div className="w-full aspect-[4/3] bg-stone-200 animate-pulse" />
//             <div className="h-2 w-20 bg-stone-200 rounded animate-pulse" />
//             <div className="h-4 w-3/4 bg-stone-200 rounded animate-pulse" />
//             <div className="h-3 w-full bg-stone-200 rounded animate-pulse" />
//           </div>
//         ))}
//       </div>
//     </div>
//   </section>
// );

// // ─── Main export ──────────────────────────────────────────────────────────────
// const BlogsSection = () => {
//   const { data, isLoading, isError } = useGetLatestBlogsPerCategoryQuery();

//   if (isLoading) return <Skeleton />;
//   if (isError || !data?.blogs?.length) return null;

//   const blogs = data.blogs;

//   return (
//     <section className="py-10 border-t border-stone-200">
//       <div className="max-w-6xl mx-auto px-6 md:px-12">

//         {/* ── Section heading ── */}
//         <motion.div
//           className="text-center mb-10"
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true, margin: "-80px" }}
//           variants={sectionVariants}
//         >
//           <motion.p
//             className="font-mono text-[0.6rem] tracking-[0.3em] uppercase text-stone-400 mb-3"
//             variants={childVariants}
//           >
//             from the blog
//           </motion.p>
//           <motion.h2
//             className="font-playfair font-normal text-stone-800 leading-tight"
//             style={{ fontSize: "clamp(1.5rem, 4vw, 2.25rem)", textWrap: "balance" }}
//             variants={childVariants}
//           >
//             Articles
//           </motion.h2>
//           <motion.p
//             className="mt-3 font-sourcesans font-normal text-stone-500 leading-relaxed max-w-xl mx-auto"
//             style={{ fontSize: "clamp(0.875rem, 2vw, 1rem)", textWrap: "balance" }}
//             variants={childVariants}
//           >
//                 Explore topics in faith, photography, movement, technology, food, and everyday adventures.
//           </motion.p>
//           <motion.div
//             className="mt-6 w-12 h-[1.5px] bg-stone-300 mx-auto"
//             variants={dividerVariants}
//             style={{ originX: 0.5 }}
//           />
//         </motion.div>

//         {/* ── Cards — always 3 ── */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
//           {blogs.slice(0, 3).map((blog, i) => (
//             <BlogCard key={blog._id || i} blog={blog} index={i} />
//           ))}
//         </div>

//         {/* ── CTA ── */}
//         <div className="text-center mt-12">
//           <motion.div
//             initial={{ opacity: 0, y: 16 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.6, delay: 0.2 }}
//           >
//             <motion.div
//               whileHover={{ scale: 1.03 }}
//               transition={{ type: "spring", stiffness: 300, damping: 18 }}
//               className="inline-block"
//             >
//               <Link
//                 to="/blogs"
//                 className="relative inline-flex items-center justify-center gap-2 px-6 py-3 font-sourcesans font-medium text-sm tracking-wide text-[#BC3F4A] overflow-hidden transition-all duration-300 border border-[#BC3F4A]/30 hover:border-[#BC3F4A]/60"
//               >
//                 Browse all posts →
//               </Link>
//             </motion.div>
//           </motion.div>
//         </div>

//       </div>
//     </section>
//   );
// };

// export default BlogsSection;


import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useGetLatestBlogsPerCategoryQuery } from "../../redux/api/blogsApi";

const FALLBACK_IMAGE = "/images/fallback.jpg";

// ─── Variants (identical to Home.jsx) ─────────────────────────────────────────
const sectionVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut", staggerChildren: 0.12 },
  },
};
const childVariants = {
  hidden: { opacity: 0, y: 12 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};
const dividerVariants = {
  hidden: { scaleX: 0 },
  visible: { scaleX: 1, transition: { duration: 0.6, ease: "easeOut", delay: 0.25 } },
};
const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, ease: "easeOut", delay: i * 0.1 },
  }),
};

// ─── Helper ───────────────────────────────────────────────────────────────────
const formatDate = (dateStr) => {
  if (!dateStr) return null;
  return new Date(dateStr).toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

const stripHtml = (str) => str?.replace(/<[^>]*>/g, "").trim() ?? "";

// ─── Blog card ────────────────────────────────────────────────────────────────
const BlogCard = ({ blog, index }) => {
  const imageUrl = blog.images?.[0]?.url || FALLBACK_IMAGE;
  const date = formatDate(blog.createdAt);
  const title = blog.name || blog.title;
  const description = stripHtml(blog.description);

  return (
    <motion.article
      custom={index}
      variants={cardVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-40px" }}
      className="group flex flex-col"
    >
      <Link to={`/blogs/${blog._id}`} className="flex flex-col h-full">

        {/* Cover image */}
        <div className="relative w-full aspect-[4/3] overflow-hidden bg-stone-200">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover object-center transition-transform duration-700 ease-out group-hover:scale-[1.03]"
            loading={index === 0 ? "eager" : "lazy"}
            decoding={index === 0 ? "sync" : "async"}
            width="600"
            height="450"
          />
        </div>

        {/* Text */}
        <div className="pt-4 flex flex-col gap-1.5 flex-1">

          {/* Category · Date */}
          <div className="flex items-center gap-2 flex-wrap">
            {blog.category && (
              <span className="font-mono text-[0.6rem] tracking-[0.28em] uppercase text-stone-400">
                {blog.category}
              </span>
            )}
            {blog.category && date && (
              <span className="font-mono text-[0.6rem] text-stone-300">·</span>
            )}
            {date && (
              <span className="font-mono text-[0.6rem] tracking-[0.2em] uppercase text-stone-400">
                {date}
              </span>
            )}
          </div>

          {/* Title */}
          <h3
            className="font-playfair font-normal text-stone-800 leading-snug group-hover:text-[#BC3F4A] transition-colors duration-300"
            style={{ fontSize: "clamp(1rem, 2vw, 1.2rem)" }}
          >
            {title}
          </h3>

          {/* Description */}
          {description && (
            <p className="font-sourcesans font-normal text-stone-500 leading-relaxed line-clamp-2 text-sm">
              {description}
            </p>
          )}

          {/* Read cue */}
          <p className="font-mono text-[0.6rem] tracking-[0.22em] uppercase text-[#BC3F4A]/70 mt-auto pt-2">
            Read →
          </p>

        </div>
      </Link>
    </motion.article>
  );
};

// ─── Skeleton ─────────────────────────────────────────────────────────────────
const Skeleton = () => (
  <section className="py-10 border-t border-stone-200">
    <div className="max-w-6xl mx-auto px-6 md:px-12">
      <div className="text-center mb-10 space-y-3">
        <div className="h-2 w-24 bg-stone-200 rounded mx-auto animate-pulse" />
        <div className="h-6 w-48 bg-stone-200 rounded mx-auto animate-pulse" />
        <div className="h-[1.5px] w-12 bg-stone-200 mx-auto mt-4" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="space-y-3">
            <div className="w-full aspect-[4/3] bg-stone-200 animate-pulse" />
            <div className="h-2 w-20 bg-stone-200 rounded animate-pulse" />
            <div className="h-4 w-3/4 bg-stone-200 rounded animate-pulse" />
            <div className="h-3 w-full bg-stone-200 rounded animate-pulse" />
          </div>
        ))}
      </div>
    </div>
  </section>
);

// ─── Main export ──────────────────────────────────────────────────────────────
const BlogsSection = () => {
  const { data, isLoading, isError } = useGetLatestBlogsPerCategoryQuery();

  if (isLoading) return <Skeleton />;
  if (isError || !data?.blogs?.length) return null;

  const blogs = data.blogs.slice(0, 6);

  return (
    <section className="py-10 border-t border-stone-200">
      <div className="max-w-6xl mx-auto px-6 md:px-12">

        {/* ── Section heading ── */}
        <motion.div
          className="text-center mb-10"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          variants={sectionVariants}
        >
          <motion.p
            className="font-mono text-[0.6rem] tracking-[0.3em] uppercase text-stone-400 mb-3"
            variants={childVariants}
          >
            from the blog
          </motion.p>

          <motion.h2
            className="font-playfair font-normal text-stone-800 leading-tight"
            style={{ fontSize: "clamp(1.5rem, 4vw, 2.25rem)", textWrap: "balance" }}
            variants={childVariants}
          >
            Articles
          </motion.h2>

          <motion.p
            className="mt-3 font-sourcesans font-normal text-stone-500 leading-relaxed max-w-xl mx-auto text-center"
            style={{ fontSize: "clamp(0.875rem, 2vw, 1rem)", textWrap: "balance" }}
            variants={childVariants}
          >
            Explore topics in faith, photography, movement, technology, food, and everyday adventures.
          </motion.p>

          {/* Category pills */}
          <motion.div
            className="mt-4 flex flex-wrap justify-center gap-2"
            variants={childVariants}
          >
            {[
              "Faith & Reflection",
              "Photography & Art",
              "Movement & Discipline",
              "Tech & Learning",
              "Kitchen & Table",
              "Stories & Adventures",
            ].map((cat) => (
              <Link
                key={cat}
                to={`/blogs?category=${encodeURIComponent(cat)}`}
                className="font-mono text-[0.6rem] tracking-[0.2em] uppercase text-stone-400 border border-stone-200 px-3 py-1 hover:border-stone-400 hover:text-stone-600 transition-colors duration-200"
              >
                {cat}
              </Link>
            ))}
          </motion.div>

          <motion.div
            className="mt-6 w-12 h-[1.5px] bg-stone-300 mx-auto"
            variants={dividerVariants}
            style={{ originX: 0.5 }}
          />
        </motion.div>

        {/* ── 3-column grid, up to 6 posts (2 rows on desktop) ── */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-x-10 md:gap-y-12">
          {blogs.map((blog, i) => (
            <BlogCard key={blog._id || i} blog={blog} index={i} />
          ))}
        </div>

        {/* ── CTA ── */}
        <div className="text-center mt-12">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <motion.div
              whileHover={{ scale: 1.03 }}
              transition={{ type: "spring", stiffness: 300, damping: 18 }}
              className="inline-block"
            >
              <Link
                to="/blogs"
                className="relative inline-flex items-center justify-center gap-2 px-6 py-3 font-sourcesans font-medium text-sm tracking-wide text-[#BC3F4A] overflow-hidden transition-all duration-300 border border-[#BC3F4A]/30 hover:border-[#BC3F4A]/60"
              >
                Browse all posts →
              </Link>
            </motion.div>
          </motion.div>
        </div>

      </div>
    </section>
  );
};

export default BlogsSection;